export const localToken = localStorage.getItem('KPMTEXTILE_BACKOFFICE_TOKEN')

export const serverApiKey = {
    WAREHOUSERPTBYROLL: 'GjasFHdoj3as33E9uasGHKdjkLsd3ofRRtnoZSKkosadfdFH93h2b4UT95oa',
    WAREHOUSERPTBYORDER: 'GjasFHdoj3as33E9uasGHKdjkLsd3ofRRtnoZSKkosadfdFH93h2b4UT95oa'
}

export const versionCode = '1.0.1'